import React from 'react';
import ConfigHeader from './elements/ConfigHeader';
import styles from './configuration.layout.module.scss';
import { Layout } from '../common';

function ConfigurationLayout({ isFirstTimeSetUp, sideContent, children, currentStep = 0, user, onStepChange }) {
    if (isFirstTimeSetUp) {
        return (
            <Layout user={user}>
                <div className={styles.configurationLayout}>
                    <ConfigHeader isFirstTimeSetUp={isFirstTimeSetUp} currentStep={currentStep} onStepChange={onStepChange} />
                    <div className={styles.contentContainer}>
                        <div className={styles.mainContent}>{children}</div>
                        <div className={styles.sideContent}>{sideContent}</div>
                    </div>
                </div>
            </Layout>
        );
    }

    // Regular configuration layout
    return (
        <Layout user={user}>
            <div className={styles.configurationLayout}>
                <ConfigHeader isFirstTimeSetUp={isFirstTimeSetUp} currentStep={currentStep} onStepChange={onStepChange} />
                <div className={styles.contentContainer}>
                    <div className={styles.mainContent}>{children}</div>
                    {sideContent && <div className={styles.sideContent}>{sideContent}</div>}
                </div>
            </div>
        </Layout>
    );
}

export default ConfigurationLayout;
